import { createTheme, Theme } from '@material-ui/core/styles';
// import {
// unstable_createMuiStrictModeTheme as createTheme,
// Theme,
// } from '@material-ui/core/styles';

import typography from 'theme/typography';
import palette from 'theme/palette';
import colors from 'theme/colors';
import overrides from 'theme/overrides';

export * from 'theme/colors';

export type CustomTheme = Theme & {
  custom?: {
    [key: string]: unknown;
  };
};

export const baseTheme = createTheme({
  // overrides,
  typography,
  palette,
  // spacing: 4, // https://material-ui.com/customization/spacing/
});

export const createCustomTheme = (themeInstance: Theme): CustomTheme => ({
  ...themeInstance,
  ...{
    /* overrides are here instead of in
     * base theme so we have access to theme.spacing() */
    overrides: overrides(themeInstance),
  },
  custom: {
    colors,
  },
});

const themeInstance = createCustomTheme(baseTheme);

export default themeInstance;
